import { useQuery } from '@tanstack/react-query';
import { KeycloakGroup } from './useInvite';

import { BehApiRoutes } from '../beh-api';

export interface UserInviteConfig {
  systemRoles: Array<KeycloakGroup>;
  groupRoles: Record<string, Array<KeycloakGroup>>;
}

export function useReadUserInviteConfig() {
  return useQuery<UserInviteConfig>({
    queryKey: [BehApiRoutes.userInvite()]
  });
}
